module.exports = __webpack_public_path__ + "img/logo-iph-portal-do-doador-instituto-pro-hemoce.64f69fc9.png";